import GenericErrorModal from './generic-error-modal';

export default GenericErrorModal;
